module.exports = __webpack_public_path__ + "img/DBS_Amira_web_0037.f9f7c54e.jpg";